var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2009 0.154033L0.238051 3.7248C0.084018 3.83682 0 4.01886 0 4.2149V9.7741C0 9.94213 0.070015 10.1102 0.210045 10.2362L4.17289 13.807C4.28492 13.919 4.43895 13.989 4.60699 13.989H9.36801C9.52204 13.989 9.67607 13.933 9.7881 13.821L13.7509 10.2642C13.891 10.1522 13.989 9.97014 13.989 9.7741V4.2149C13.989 4.03287 13.919 3.86483 13.779 3.7528L9.8161 0.182039C9.70408 0.070015 9.55005 0 9.36801 0H4.60699C4.46696 0 4.31293 0.056012 4.2009 0.154033ZM6.37137 7.14153L6.0633 4.35493C6.00729 3.86483 6.5114 3.41673 6.9875 3.41673C7.4636 3.41673 7.98171 3.86483 7.9257 4.35493L7.61763 7.14153C7.57562 7.49161 7.33757 7.77167 6.9875 7.77167C6.65143 7.77167 6.41338 7.49161 6.37137 7.14153ZM6.9875 8.69586C7.50561 8.69586 7.9257 9.11596 7.9257 9.63407C7.9257 10.1522 7.50561 10.5723 6.9875 10.5723C6.48339 10.5723 6.0633 10.1522 6.0633 9.63407C6.0633 9.11596 6.48339 8.69586 6.9875 8.69586Z",
    fill: "#8B1303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDeactivated);
export default __webpack_public_path__ + "static/media/account-deactivated.63088cc0b27c1ba0b4439210ef5b7966.svg";
export { ForwardRef as ReactComponent };